"use client";

import Image, { type ImageProps } from "next/image";
import { useState } from "react";

type DetailImageProps = Omit<ImageProps, "alt" | "src" | "onError"> & {
  alt: string;
  src: string;
  fallbackSrc: string;
};

export default function DetailImage({
  alt,
  src,
  fallbackSrc,
  quality = 75,
  ...props
}: DetailImageProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const activeSrc = failedSrc === src ? fallbackSrc : src;

  return (
    <Image
      {...props}
      alt={alt}
      src={activeSrc}
      quality={quality}
      onError={() => {
        if (activeSrc !== fallbackSrc) setFailedSrc(src);
      }}
    />
  );
}
